export default __webpack_public_path__ + "static/media/New York.079f2d27.png";